import React from 'react';
import {
  Box, Text, Heading
} from '@myob/myob-widgets';
import { Image } from 'components/image/Image';
import ArrowIcon from 'assets/svg/chevron_up_icon.svg';
import style from './ProductHeading.module.scss';
import modernStyle from './ProductHeading.modern.module.scss';
import commonStyle from './ProductHeading.common.module.scss';
import { getStyleProps } from './ProductHeading.style';
import { FEELIX_THEMES } from '../../../constants';

type ProductHeadingProps = {
  heading: string;
  isFooterOpen: boolean;
  theme: string;
}
export const PRODUCT_CARD_HEADING = 'Summary of your plan';
export const PRODUCT_CARD_PLAN_SUMMARY_HEADING = 'Plan summary';

export const ProductHeading = (
  {
    heading,
    isFooterOpen,
    theme
  }: ProductHeadingProps
) => {
  const styleProps = getStyleProps(theme);
  const shouldUseModernStyle = [FEELIX_THEMES.MODERN, FEELIX_THEMES.PARTNER].includes(theme);
  const isCommonTheme = theme === FEELIX_THEMES.COMMON;

  return (
    <Box
      {...styleProps.container}
      className={[
        {
          [modernStyle.heading]: shouldUseModernStyle
        }
      ]}
    >
      <Image
        className={[
          isFooterOpen ? style.chevronOpen : style.chevron,
          isCommonTheme && commonStyle.chevronCommon
        ].filter(Boolean).join(' ')}
        src={ArrowIcon}
        alt='arrow'
      />
      {!isCommonTheme && (
        <Text
          className={[
            style.rowOne,
            { [modernStyle.rowOne]: shouldUseModernStyle }
          ]}
          data-content-desktop={PRODUCT_CARD_HEADING}
          data-content-mobile={heading}
          {...styleProps.rowOne}
        />
      )}
      <Heading
        className={[style.rowTwo, {
          [modernStyle.rowTwo]: theme === FEELIX_THEMES.MODERN,
          [commonStyle.rowTwo]: isCommonTheme
        }]}
        data-content-desktop={isCommonTheme ? PRODUCT_CARD_PLAN_SUMMARY_HEADING : heading}
        data-content-mobile={isCommonTheme ? PRODUCT_CARD_PLAN_SUMMARY_HEADING : PRODUCT_CARD_HEADING}
        {...styleProps.rowTwo}
      />
    </Box>
  );
};
